// https://digital.vfc.com/wiki/spaces/AN/pages/356786124/Country+and+Langugage+Selectors

const baseEvent = {
  event: 'loadEventData',
  eventCategory: 'Language Selector',
  nonInteractive: 0,
  customMetrics: {},
  customVariables: {}
}

export default {
  onImpression: () => ({
    ...baseEvent,
    eventAction: 'Popup',
    eventLabel: 'Impression',
  }),
  onClickLanguageSelector: (eventLabel: string, eventAction: string) => ({
    ...baseEvent,
    eventAction,
    eventLabel: `Switch to ${eventLabel}`
  })
}
